import { DropdownOption } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { DropdownMenu } from 'src/app/shared/atomic/organisms/member-card/member-card.types';
import { ICON } from '@core/util/icon';

export enum ClientKebabOptionTypes {
	QUICK_EDIT = 'Quick edit',
	GLOBAL = 'View global',
}

export const clientKebabOptions: DropdownOption<ClientKebabOptionTypes>[] = [
	{
		name: 'Quick edit',
		value: ClientKebabOptionTypes.QUICK_EDIT,
	},
	{
		name: 'View global profile',
		value: ClientKebabOptionTypes.GLOBAL,
	},
];

export const contactCardDropdownItems: DropdownMenu = [
	{
		icon: ICON.OVERVIEW,
		id: '1',
		name: 'View global',
	},
	{
		icon: ICON.EDIT,
		id: '2',
		name: 'Quick edit',
	},
];

export const contactCardLawfirmDropdownItems: DropdownMenu = [
	{
		icon: ICON.EDIT,
		id: '1',
		name: 'Quick edit',
	},
];
